import { render, staticRenderFns } from "./VendorBadanUsahaGEMS.vue?vue&type=template&id=b9d7d5f2&"
import script from "./VendorBadanUsahaGEMS.vue?vue&type=script&lang=js&"
export * from "./VendorBadanUsahaGEMS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports